import { useState } from 'react';
import type { FAQItem } from '@/mocks/articles';

interface FAQProps {
  items: typeof import('@/mocks/articles').faqs;
}

interface FAQItem {
  question: string;
  answer: string;
}

export default function FAQ({ items }: FAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <div className="space-y-3">
        {items.map((item, index) => (
          <div
            key={index}
            className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden"
          >
            <button
              className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <span className="text-sm font-medium text-foreground-950 pr-4">
                {item.question}
              </span>
              <i
                className={`text-lg text-foreground-500 flex-shrink-0 transition-transform duration-300 ${
                  openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                }`}
              ></i>
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              }`}
            >
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}